import { render, staticRenderFns } from "./ErrorMessageCustomLinksContainer.vue?vue&type=template&id=70899696&scoped=true&"
import script from "./ErrorMessageCustomLinksContainer.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageCustomLinksContainer.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessageCustomLinksContainer.vue?vue&type=style&index=0&id=70899696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70899696",
  null
  
)

export default component.exports